import shuffle from 'lodash.shuffle';
import notify from '@/plugins/notify';
import api from '../../helpers/api';
import { chatColors, IChatState, IChatUser } from './Chat-types';

const chatState: IChatState = {
    state: {
        colors: [],
        expanded: false,
        gameId: null,
        lastColorIndex: 0,
        messages: [],
        readMessages: [],
        show: false,
        users: [],
    },
    mutations: {
        setColors(state, colors: string[]) {
            state.colors = colors;
        },
        setExpanded(state, expanded: boolean) {
            state.expanded = expanded;
        },
        setGameId(state, gameId: number) {
            state.gameId = gameId;
        },
        setMessages(state, messages: string[]) {
            state.messages = messages;
        },
        setReadMessages(state, messages: string[]) {
            state.readMessages = messages;
        },
        setLastColorIndex(state, index: number) {
            state.lastColorIndex = index;
        },
        setChatUsers(state, users: IChatUser[]) {
            state.users = users;
        },
        setShowChat(state, show: boolean) {
            state.show = show;
        },
    },
    actions: {
        async getMessages({ commit, state }, gameId: number) {
            const response = await api.request(`/chat/${gameId}/messages`);
            const messages: string[] = await response.json();

            if (response.ok) {
                commit('setMessages', messages);

                if (state.expanded) {
                    commit('setReadMessages', messages);
                }
            }
        },
        setColors({ commit, state }, gameId: number) {
            if (gameId !== state.gameId) {
                commit('setColors', shuffle(chatColors));
                commit('setChatUsers', []);
            }
        },
        setExpanded({ commit, state }, expanded: boolean) {
            commit('setExpanded', expanded);

            if (expanded) {
                commit('setReadMessages', state.messages);
            }
        },
        setGameId({ commit }, gameId: number) {
            commit('setGameId', gameId);
        },
        setMessages({ commit }, messages: string[]) {
            commit('setMessages', messages);
        },
        setReadMessages({ commit }, messages: string[]) {
            commit('setReadMessages', messages);
        },
        async sendMessage({}, options: any) {
            const { gameId, message } = options;
            const response = await api.request(`/chat/${gameId}/message`, 'POST', { message });
            let errorMsg = '';
            let title = 'Error';

            if (!response.ok) {
                if (response.status === 400) {
                    errorMsg = 'Spectators cannot participate in the chat';
                } else {
                    errorMsg = (await response.json())?.message ?? 'Unknown error';
                }

                if (response.status === 403) {
                    title = 'Banned';
                }

                if (errorMsg) {
                    notify({
                        group: 'app',
                        title,
                        type: 'error',
                        text: errorMsg,
                    });
                }
            }
        },
        setLastColorIndex({ commit }, index: number) {
            commit('setLastColorIndex', index);
        },
        setChatUsers({ commit }, users: IChatUser[]) {
            commit('setChatUsers', users);
        },
        setShowChat({ commit }, value: boolean) {
            commit('setShowChat', value);
        },
    },
};

export default chatState;
